import React from 'react'
import PropTypes from 'prop-types'

import { Info as InfoIcon, Check as CheckIcon } from 'react-feather'
import { Box, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import theme from 'theme'

const AgeGateSourceCodeDialog = ({ open, setOpen }) => {
  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Como instalar o Controle de Idade no HTML (Via código fonte)"
      fullWidth
      closeIconButton
      withoutBottomDivider
      dialogSize="md"
    >
      <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
        <Box
          p={2}
          bgcolor={theme.palette.custom.light}
          borderRadius={1}
          display="flex"
          alignItems="center"
          gridGap={theme.spacing(2)}
        >
          <Box>
            <InfoIcon color={theme.palette.primary.main} />
          </Box>
          <Typography color="primary" mt={1}>
            Para inserir o código do Controle de Idade, é necessário ter acesso
            ao código-fonte do seu site.
          </Typography>
        </Box>
        <Box
          p={2}
          bgcolor={theme.palette.custom.light}
          borderRadius={1}
          display="flex"
          alignItems="center"
          gridGap={theme.spacing(2)}
        >
          <Box>
            <InfoIcon color={theme.palette.primary.main} />
          </Box>
          <Typography color="primary" mt={1}>
            O overlay do Controle de Idade é renderizado dentro da{' '}
            <strong>{'<div id="age-gate">'}</strong>. O script deve ser inserido{' '}
            <strong>após essa div</strong> ou no <strong>&lt;head&gt;</strong>{' '}
            do site, para garantir que o elemento já exista quando o script for
            executado.
          </Typography>
        </Box>
        <Box
          borderRadius={1}
          display="flex"
          flexDirection="column"
          gridGap={theme.spacing(2.5)}
        >
          <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
            <CheckIcon />
            <Typography>
              Clique em <strong>VER CÓDIGO</strong>
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
            <CheckIcon />
            <Typography>
              Selecione todo o código ou utilize o botão de copiar
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
            <CheckIcon />
            <Typography>
              Adicione a <strong>{'<div id="age-gate"></div>'}</strong> no corpo
              do site — é nela que o modal será exibido
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
            <CheckIcon />
            <Typography>
              Cole o <strong>&lt;script&gt;</strong> logo após a div ou no{' '}
              <strong>&lt;head&gt;</strong>, sem outras tags interferindo
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
            <CheckIcon />
            <Typography>Salve as alterações</Typography>
          </Box>
        </Box>
      </Box>
    </BaseDialog>
  )
}

AgeGateSourceCodeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default AgeGateSourceCodeDialog
